import { uniq } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectFilteredBookingsForRange } from '../../core/state/bookings/selectors';
import { RootState } from '../../core/state/state';
import DeliveryZoneBadge from '../components/delivery-zone-badge/DeliveryZoneBadge';

const BookingPrintZones: React.FC = () => {
  const selectedDate = useSelector((state: RootState) => state.bookings.selectedDate);
  const bookings = useSelector((state: RootState) => selectFilteredBookingsForRange(state, selectedDate));
  const zones = uniq(bookings.map((item) => item.deliveryZoneId));

  return (
    <div className="d-none d-print-flex mt-3">
      {zones.map((item) => (
        <div key={item} className="mr-2 mb-2">
          <DeliveryZoneBadge key={item} id={item} />
        </div>
      ))}
    </div>
  );
};

export default BookingPrintZones;
